/* istanbul ignore file */
import { BigFormRow } from 'framework/ui/layout';
import { CandidateResumeUploaderInput } from 'domain/shared/candidate';
import ResumeWysiwygInput from 'domain/recruiting/candidate/shared/input/ResumeWysiwygInput';

const ResumeForm = () => {
  return (
    <>
      <BigFormRow>
        <ResumeWysiwygInput artifactsSource="artifacts" source="description" />
      </BigFormRow>
      <BigFormRow>
        <CandidateResumeUploaderInput label="Candidate resume" source="artifacts" />
      </BigFormRow>
    </>
  );
};

export default ResumeForm;
